import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { scrollToPartnerForm } from '@shared/components/forms/partner'
import PageAnimation from '@shared/components/page-animation'
import { Section } from '@shared/components/section'
import { PartnerFormSection } from '@shared/components/sections/partner-form-section'
import { PartnerLogos } from '@shared/components/sections/partner-logos'
import { ProductLoans } from '@shared/components/sections/product-loans'
import { StepsNoSection } from '@shared/components/sections/steps'

import { mainBlock, partnerFormSummary, productListLoan } from '../../data/referral-partners'

import { Reasons } from './sections/reasons'
import { stepsData } from './sections/steps/data'

import styles from './style.module.scss'

export const View = () => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			imageAdornmentWrapClassName={styles.imageAdornment}
			imageClassname={styles.imageClassname}
			data={{
				...mainBlock,
			}}
			buttonProps={{
				onClick: scrollToPartnerForm,
			}}
		/>
		<PartnerLogos />
		<ProductLoans productList={productListLoan} />
		<Section className={styles.reasonWrap}>
			<h2 className={styles.sectionTitle}>Кому подходит реферальная программа</h2>
			<Reasons />
		</Section>
		<Section className={styles.benefitWrap} fullWidth>
			<h2 className={styles.sectionTitle}>Зарабатывайте до 20 тысяч рублей за сделку</h2>
			<p className={styles.benefitText}>
				Размер вознаграждения зависит от суммы займа клиента: чем больше заём, тем выше комиссия.
				Количество сделок в месяц не ограничено.
			</p>
		</Section>
		<Section className={styles.stepsWrap}>
			<h2 className={styles.sectionTitle}>Как работает программа</h2>
			<StepsNoSection steps={stepsData} stepTextStyles={styles.stepTextStyles} />
		</Section>
		<PartnerFormSection summary={partnerFormSummary} btnText='Подключиться к программе' />
	</PageAnimation>
)
